import React from "react";

import Main from "../layouts/main";

export default function(props) {
  return (
    <Main title="About Us" subTitle="Learn more about CaribbeanO" {...props}>
      <p>
        <span className="highlight1">VoiceLine is a low-cost phone service</span> that is an
        alternative to your traditional phone line. With a telephone, broadband Internet connection
        and a telephone adapter, VoiceLine allows you to make and receive calls at home or anywhere
        in the world. Since calls route through the Internet, the costs are less and the savings are
        passed onto you.
      </p>
      <h3>Getting started</h3>
      <p>Getting started with VoiceLine is easy! You will need:</p>
      <ul>
        <li>A broadband Internet connection (DSL, cable, T1, or satellite)</li>
        <li>An InnoMedia telephone adapter</li>
        <li>A VoiceLine account and phone number</li>
        <li>A regular telephone (cordless or wired)</li>
      </ul>
      <p>
        Once you receive your telephone adapter, setup is simple. Plug your phone into your
        telephone adapter and then connect the adapter to your broadband modem. For more
        information, ask for our Installation Tutorial.
      </p>
      <h3>Monthly calling plans</h3>
      <p>
        VoiceLine offers a variety of calling plans to meet your unique calling needs. Each monthly
        plan includes either unlimited or a fixed number of minutes to select in-plan destinations.
      </p>
      <h3>Calling features</h3>
      <p>
        All monthly calling plans include great features such as VoiceMail, call waiting, caller ID,
        3-way calling, and call forwarding -- at no extra charge. VoiceLine-to-VoiceLine calls are
        also free.
      </p>
      <h3>Pay-As-You-Go calling plan</h3>
      <p>
        If a monthly calling plan isn't right for you, you can choose a Pay-As-You-Go plan. With
        Pay-As-You-Go, you pay per-minute rates for all of your inbound and outbound calls. Simply
        add funds to open your account and make calls
      </p>
      <h3>Your VoiceLine phone number</h3>
      <p>
        VoiceLine lets you choose from phone numbers in the U.S. and Canada or a U.S., CA or U.K.
        toll-free number, regardless of where you live. Depending on the number you choose, your
        VoiceLine number can allow your family and friends to call you for less. For example, if you
        live in Montreal, Canada, and have family in Miami, Florida, you can choose a phone number
        with a Miami area code. Now, when your family calls you, they will be charged the cost of a
        local call -- even though they are speaking to you in Montreal!
      </p>
      <p>
        <span>
          VoiceLine customers can choose one or more phone numbers from countries all over the
          world, including:
        </span>
        <br />
        <br />
      </p>
      <table width="90%" border="0">
        <tbody>
          <tr>
            <td width="25%">
              <strong>Argentina</strong>
            </td>
            <td width="25%">
              <strong>Finland</strong>
            </td>
            <td width="25%">
              <strong>New Zealand</strong>
            </td>
            <td width="25%">
              <strong>Sweden</strong>
            </td>
          </tr>
          <tr>
            <td width="25%" height="14">
              <strong>Austria</strong>
            </td>
            <td width="25%" height="14">
              <strong>France</strong>
            </td>
            <td width="25%" height="14">
              <strong>Norway</strong>
            </td>
            <td width="25%" height="14">
              <strong>U.K.</strong>
            </td>
          </tr>
          <tr>
            <td width="25%" height="13">
              <strong>Belgium</strong>
            </td>
            <td width="25%" height="13">
              <strong>Georgia</strong>
            </td>
            <td width="25%" height="13">
              <strong>Panama</strong>
            </td>
            <td width="25%" height="13">
              <strong>U.S.</strong>
            </td>
          </tr>
          <tr>
            <td width="25%">
              <strong>Brazil</strong>
            </td>
            <td width="25%">
              <strong>Hong Kong</strong>
            </td>
            <td width="25%">
              <strong>Peru</strong>
            </td>
            <td width="25%">
              <strong>Vietnam</strong>
            </td>
          </tr>
          <tr>
            <td width="25%">
              <strong>Canada</strong>
            </td>
            <td width="25%">
              <strong>Japan</strong>
            </td>
            <td width="25%">
              <strong>Poland</strong>
            </td>
            <td width="25%"> </td>
          </tr>
          <tr>
            <td width="25%">
              <strong>Chile</strong>
            </td>
            <td width="25%">
              <strong>Lithuania</strong>
            </td>
            <td width="25%">
              <strong>Portugal</strong>
            </td>
            <td width="25%"> </td>
          </tr>
          <tr>
            <td width="25%">
              <strong>Cyprus</strong>
            </td>
            <td width="25%">
              <strong>Luxembourg</strong>
            </td>
            <td width="25%">
              <strong>Puerto Rico</strong>
            </td>
            <td width="25%"> </td>
          </tr>
          <tr>
            <td>
              <strong>Denmark</strong>
            </td>
            <td>
              <strong>Malta</strong>
            </td>
            <td>
              <strong>Slovenia</strong>
            </td>
            <td> </td>
          </tr>
          <tr>
            <td>
              <strong>El Salvador</strong>
            </td>
            <td>
              <strong>Mexico</strong>
            </td>
            <td>
              <strong>South Africa</strong>
            </td>
            <td> </td>
          </tr>
          <tr>
            <td>
              <strong>Estonia</strong>
            </td>
            <td>
              <strong>Netherlands</strong>
            </td>
            <td>
              <strong>Spain</strong>
            </td>
            <td> </td>
          </tr>
        </tbody>
      </table>
      <p>
        So, for example, if your customer in Brazil has friends, family or business contacts in
        Portugal, they can obtain a Portugal phone number and their contacts in Portugal can call
        them without incurring international long distance charges.
      </p>
      <p> </p>
      <h3>Manage your account online</h3>
      <p>
        You can log into the VoiceLine account center for a summary of your account, recent calls,
        and transactions. You can also listen to your VoiceMail messages, manage your feature
        settings, and update your account information.
      </p>
      <p>
        <strong>Additional customer benefits</strong>
        <br />
        Callers can also benefit from a full suite of popular calling features, including:
      </p>
      <table width="90%" border="0">
        <tbody>
          <tr>
            <td width="33%">
              <strong>VoiceMail</strong>
            </td>
            <td width="33%">
              <strong>Speed Dial</strong>
            </td>
            <td width="34%">
              <strong>Call Forwarding</strong>
            </td>
          </tr>
          <tr>
            <td width="33%" height="19">
              <strong>Reach Me</strong>
            </td>
            <td width="33%" height="19">
              <strong>Call Return</strong>
            </td>
            <td width="34%" height="19">
              <strong>Automatic Callback</strong>
            </td>
          </tr>
          <tr>
            <td width="33%" height="13">
              <strong>Caller ID</strong>
            </td>
            <td width="33%" height="13">
              <strong>Do Not Disturb</strong>
            </td>
            <td width="34%" height="13">
              <strong>3-Way Calling</strong>
            </td>
          </tr>
          <tr>
            <td width="33%">
              <strong>Call Waiting</strong>
            </td>
            <td width="33%">
              <strong>Call Transfer</strong>
            </td>
            <td width="34%">
              <p>
                <strong>Anonymous Call Blocking</strong>
              </p>
              <p>
                <strong>ETC</strong>
              </p>
              <p>
                <strong>
                  <br />
                </strong>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </Main>
  );
}
